export default __webpack_public_path__ + "static/media/actionsIcon.d3869b8b.svg";